import { Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { Directive } from '@angular/core';

@Directive()
export abstract class EaSimulationSoficaFormBuilder extends PrFormAbstract {
  options: any = {};

  generate(entity: any, options) {
    this.options = options;
    return this.formBuilder.group(
      {
        investedAmount: [
          entity ? entity.investedAmount : null,
          Validators.required,
        ],
        reductionRate: [
          entity ? this.formatDisplayReductionRate(entity) : null,
          Validators.required,
        ],
      },
      {},
    );
  }

  extract() {
    let dto: any = {
      investedAmount: this.emptyIsNull(this.form.value.investedAmount),
    };
    dto = {
      ...dto,
      ...this.formatIncreaseCondition(this.form.value.reductionRate),
    };

    return dto;
  }

  formatDisplayReductionRate(entity) {
    if (
      !entity.increaseCondition1 &&
      !entity.increaseCondition2a &&
      !entity.increaseCondition2b
    ) {
      return 30;
    } else if (
      entity.increaseCondition1 &&
      !entity.increaseCondition2a &&
      !entity.increaseCondition2b
    ) {
      return 36;
    } else {
      return 48;
    }
  }

  formatIncreaseCondition(reductionRate) {
    if (reductionRate === 30) {
      return {
        increaseCondition1: false,
        increaseCondition2a: false,
        increaseCondition2b: false,
      };
    } else if (reductionRate === 36) {
      return {
        increaseCondition1: true,
        increaseCondition2a: false,
        increaseCondition2b: false,
      };
    } else {
      return {
        increaseCondition1: true,
        increaseCondition2a: true,
        increaseCondition2b: true,
      };
    }
  }
}
